import React, { useEffect } from 'react'
import { useTranslation } from 'react-multi-lang'
import { useDispatch, useSelector } from 'react-redux'
import DetailsModal from '../../../components/DetailsModal/DetailsModal'
import API from '../../../services/api/api'
import { showProductSlice, showProductState } from './ShowModalSlice'
import { havePermission } from '../../../services/hoc/permissions'
import { Confirm } from '../../../components/Alerts/Alerts'
import { productsSlice } from '../PricingSlice'
import { addProductSlice } from '../AddModal/AddModalSlice'
import { useCookies } from 'react-cookie'
import { useAPI } from '../../../services/hoc/useAPI'

const ShowProduct = ({close}:{close:Function}) => {

    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector((state: { show_product: showProductState }) => state.show_product)

const ENDPOINTS = useAPI()
    const toggle = () =>{ 
        close()
        dispatch(showProductSlice.actions.setIsOpen({ id: state.id, isOpen: false }))}

    const fetchData = () => {

        ENDPOINTS.products().show({ id: state.id })
            .then((response: any) => {
                dispatch(showProductSlice.actions.setIsLoaded(true))
                dispatch(showProductSlice.actions.setData({
                    name: response.data?.data?.name,
                    description: response.data?.data?.description,
                    serial_number: response.data?.data?.serial_no,
                    price: response.data?.data?.price,
                    materials: response.data?.data?.components.filter((component: any) => component.type === "material").map((component: any) => ({
                        id: component.component_id,
                        name: component.name,
                        amount: component.amount,
                        attributes: component.attributes_list.map((item: any) => ({
                            name: item.name,
                            value: item.value
                        }))
                    })),
                    services: response.data?.data?.components.filter((component: any) => component.type === "service").map((component: any) => ({
                        id: component.component_id,
                        name: component.name,
                        amount: component.amount,
                        attributes: component.attributes_list.map((item: any) => ({
                            name: item.name,
                            value: item.value
                        }))
                    }))
                }))
            })

    }


    // Delete
    const remove = (id: number) => {
        let ids = [id]
        dispatch(productsSlice.actions.setIsLoading(true))
        ENDPOINTS.products().delete({ ids })
            .then(() => {
                toggle()
                dispatch(productsSlice.actions.setIsLoading(false))
            
                dispatch(productsSlice.actions.deleteprices(ids))
            })
    }

    useEffect(() => {
        dispatch(showProductSlice.actions.setIsLoaded(false))
        if (state.id !== 0)
            fetchData()
    }, [state.id])

    return (
        <DetailsModal data={state.data} isOpen={state.isOpen} isLoading={!state.isLoaded} toggle={toggle} title={t("product_details")} actions={
            <div className="show-on-hover">
                {havePermission("Edit Product") ?
                    <i className="icon-edit" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation()
                        toggle()
                        dispatch(addProductSlice.actions.setIsOpen(true))
                        dispatch(addProductSlice.actions.setIsLoading(true))
                        dispatch(addProductSlice.actions.setEditId(state.id))
                        ENDPOINTS.products().show({ id: state.id })
                            .then((response: any) => {
                                dispatch(addProductSlice.actions.set({
                                    name: response.data?.data?.name,
                                    description: response.data?.data?.description,
                                    serial_no: response.data?.data?.serial_no,
                                    price: response.data?.data?.price,
                                    materials: response.data?.data?.components.filter((component: any) => component.type === "material").map((component: any) => ({
                                        id: Number(component.component_id),
                                        amount: component.amount,
                                        attributes: component.attributes_list.map((item: any) => ({
                                            attribute_id: item.attribute_id,
                                            value: item.value
                                        }))
                                    })),
                                    services: response.data?.data?.components.filter((component: any) => component.type === "service").map((component: any) => ({
                                        id: Number(component.component_id),
                                        amount: component.amount,
                                        attributes: component.attributes_list.map((item: any) => ({
                                            attribute_id: item.id,
                                            value: item.value
                                        }))
                                    }))
                                }))
                                dispatch(addProductSlice.actions.setIsLoading(false))
                            })
                    }} /> : ""}
                {havePermission("Delete Product") ?
                    <i className="icon-delete" onClick={(e: React.MouseEvent<HTMLLIElement>) => {
                        e.stopPropagation()
                        Confirm({
                            message: t("delete_confirmation"),
                            onConfirm: () => remove(state.id)
                        })
                    }} /> : ""}
            </div>
        } />
    )

}

export default ShowProduct